import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateIdentification,
    Identification,
    IdentificationListResponse,
    IdentificationQueryParams,
    UpdateIdentification
} from '@frontend/identification/types';

export class MyIdentificationClient extends APIClient {
    public static readonly endpoint = '/identification-api/my/v1';

    public static async fetchIdentifications(queryParams?: ApiQueryParams<IdentificationQueryParams>): Promise<IdentificationListResponse> {
        return await this.apiPaginated<IdentificationListResponse, IdentificationQueryParams>(`${this.endpoint}/identifications`, queryParams);
    }

    public static async postIdentification(accountId: string, body: CreateIdentification): Promise<Identification> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/identifications`, body);
        return await this.handleResponse<Identification>(response);
    }

    public static async patchIdentification(accountId: string, identificationId: string, body: UpdateIdentification): Promise<Identification> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/identifications/${identificationId}`, body);
        return await this.handleResponse<Identification>(response);
    }

    public static async deleteIdentification(accountId: string, identificationId: string, forceDelete = false): Promise<void> {
        const endpoint = `${this.endpoint}/accounts/${accountId}/identifications/${identificationId}${forceDelete ? '?force_delete=true' : ''}`;
        const response = await this.delete(endpoint);
        return await this.handleVoidResponse(response);
    }
}
